function countCart() {
  $("header .cart").addClass("active");
   $.ajax({
    url: '/cart',
    method: 'GET',
    dataType: 'json',
    success: function(data) {  
      $('.bagamount').html(data.item_count);
      if (data.item_count > 0) {
          $("header .cart").addClass("cart-clr-active");
      }else{
          $("header .cart").removeClass("cart-clr-active");
      }
      setTimeout(function(){
         $("header .cart").removeClass("active");
      },1000);
    }
  });
}
$( document ).ready(function() {
// MEGA MENU JS=================
$("body").on("click", ".menu_item", function (e) {
  e.preventDefault();
  var $this = $(this);
  var $megaMenu = $this.parents(".menu_list").find('.mega_menu_main');
  if ($megaMenu.length) { // Check if .mega_menu_main exists
    if ($this.hasClass('is-open')) {
        $this.removeClass('is-open');
        $('.mega_menu_main').removeClass('is-open');
    } else {
        $('.menu_item, .mega_menu_main').removeClass('is-open');
        $this.addClass('is-open');
        $this.parents(".menu_list").find('.mega_menu_main').addClass('is-open');
    }
   }else{
    var url = $(this).attr("href"); // Get the URL from the href attribute
    window.location.href = url;
   }
});
$(".template-index .header").removeClass("bg_added");
// HEADER CLASS ADD AND REMOVE=================
// $(window).scroll(function () {    
//   var scroll = $(window).scrollTop();
//   if (scroll >= 100) {
//       $(".header").addClass("bg_added");
//   } else {
//       $(".template-index .header").removeClass("bg_added");
//   }
// });


// MOBILE MENU===================
$("body").on("click", ".toggle_menu", function (e) {
  e.preventDefault();
  $('.search_bar_main').removeClass('is-open');
  if ($(this).hasClass("is-open")) {
    $(this).removeClass("is-open");
    $(".menu_overlay, .header_center, body").removeClass("is-open");
  } else {
    $(this).addClass("is-open");
    $(".menu_overlay, .header_center, body").addClass("is-open");
  }
});
$("body").on("click", ".menu_overlay", function (e) {
  e.preventDefault();
  $(".menu_overlay, .header_center, .toggle_menu, body").removeClass("is-open");
});

// SEARCH BAR =================
 // function PosEnd(end) {
 //    // var len = end.value.length;
     
 //    // Mostly for Web Browsers
 //    if (end.setSelectionRange) {
 //        end.focus();
 //        end.setSelectionRange(len, len);
 //    } else if (end.createTextRange) {
 //        var t = end.createTextRange();
 //        t.collapse(true);
 //        t.moveEnd('character', len);
 //        t.moveStart('character', len);
 //        t.select();
 //    }
 //  }
if (!$('body').hasClass('template-search')) {
$("body").on("click", ".search_bar_block, .mob_search_icon", function (e) {
    e.preventDefault();
    // Close any open menu if necessary
    if ($('.header_center').hasClass('is-open')) {
        $('.header_center, .toggle_menu, .menu_overlay').removeClass('is-open');
    }

    // Open search bar
    $('.search_bar_main, body').addClass('is-open');

   $('input[name="q"]').focus()
  
  //   setTimeout(function(){
  //       $('input[name="q"]').focus()
  // },50);
});

$("body").on("click", ".search_close_block", function (e) {
  $('.search_bar_main, body').removeClass('is-open');
});

// HEADER HEIGHT GETTING=================
// function headerspace() {
//   if($(window).width() < 992){
//     $('.wrapper').css("padding-top", 0)
//   }
//   else{
//      $('body:not(.template-index) .wrapper').css("padding-top", $(".header").outerHeight()+'px');
//     console.log("fghfgh")
//   }
//  } 
//  headerspace();
//  $(window).on('resize orientationchange', function () {
//     headerspace();
// });

// PRODUCT PAGE PDP SLIDER======================
if ($('.template-product').length > 0) {
  // var P_thumbs1 = new Swiper ('.pdp_gallery_thumbs', {
  //     slidesPerView: 4,
  //     watchSlidesVisibility: true,
  //     watchSlidesProgress: true,
  //     breakpoints: {
  //       526: {
  //         slidesPerView: 5,
  //       }
  //     }
  // });
  // var P_slider1 = new Swiper ('.pdp_gallery_slider', {
  //     slidesPerView: 1,
  //     thumbs: {
  //       swiper: P_thumbs1,
  //     },
  // });

  // PDP POPUP===================
  $("body").on("click", ".also-like .black_btn", function (e) {
      e.preventDefault();
      $('.also_like_popup, body').addClass('is-open');
  });
  $("body").on("click", ".also_popup_overlay, .also_popup_close", function (e) {
      e.preventDefault();
      $('.also_like_popup, body').removeClass('is-open');
  });
}

$("body").on("click", ".share_item_pop a", function (e) {
    e.preventDefault();
    $(this).closest('.pr_inner_row').find('.share_popup').addClass('is-open');
    $('body').addClass('is-open');
});
$("body").on("click", ".share_btl_close a, .share_popup_overlay", function (e) {
    e.preventDefault();
    $(this).closest('.pr_inner_row').find('.share_popup').removeClass('is-open');
    $('body').removeClass('is-open');
});

// Ajax Search
$(document).on("keyup", "input.q, input.q1", function (event) {
  var search_for = $(this).val();
  console.log("search_for", search_for)
  var ajax_url = "/search/suggest?q=" + search_for + "&section_id=predictive-search";
    $.get(ajax_url, function (data, status) {
      if (search_for) {
        $(".predictive-search-result-div").html(data);
      }
    });
});
}

// main product add to cart
// $('.green_btn').on('click', function() {
//     $('#add-to-cart-form').submit();
// });

$('body').on('click', '.add-to-cart', function (event) {
    event.preventDefault(); 
   var productId;
    if ($(this).hasClass('SAMPLEOPTIONADD')) {
      productId = $('form#add-to-cart1 input[name="id"]').val();
    } else {
      if ($("#product-select").val() !== undefined) {
          productId = $("#product-select").val();
      } else {
          productId = $(".pdp_info_option input").val();
      }
     var template = $(this).data('template');
      console.log("template",template);
      if(template == "bath-template"){
         productId = $('form#add-to-cart1 input[name="id"]').val();
      }
    }
    var p_qtv = $(".measurement_box").val();
    console.log("producqty", p_qtv);
    var data = {
        items: []
    };
    var mainproduct = {};
    mainproduct['id'] = productId;
    mainproduct['quantity'] = p_qtv;
    if ($(this).hasClass('SAMPLEOPTIONADD')) {
      var skuValue = $(this).data('sku');
       mainproduct['properties'] = {__sampleOrder: true, SKU:skuValue  };
    }

    data.items.push(mainproduct);
    console.log("mainproduct", mainproduct);

    console.log(data['items']);

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (data) {
          countCart();
           $('.pdp_variation-price_top .measurement-per-unit').val(1);
           $('.pdp_variation-price_top .measurement-quantity').val(1.44);
          $('.also_like_popup, body').removeClass('is-open');
          $('.woocommerce-message').css("display","block");
           setTimeout(function () {
             $('.woocommerce-message').css("display","none");
           }, 3000);
          // $('html, body').animate({
          //   scrollTop: $(".woocommerce-message").offset().top - $("header.header").height()
          // }, 200)
            // console.log('success');
            //  setTimeout(function() {
            //     window.location.href = '/cart';
            // }, 500);
        },
        error: function () {
            console.log('error');
        }
    });
});

});